if (!customElements.get('product-gallery')) {
  customElements.define('product-gallery', class ProductGallery extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    init() {
      const pswpElement = document.querySelectorAll('.pswp')[0];
      const galleryElements = document.querySelectorAll('product-gallery');

      galleryElements.forEach((galleryElement) => {
        const images = Array.from(galleryElement.querySelectorAll('img')).filter(img => img.offsetParent !== null);
        const items = [];

        images.forEach((image) => {
          items.push({
            src: image.src,
            w: image.naturalWidth,
            h: image.naturalHeight,
          });

          image.addEventListener('click', (e) => {
            e.preventDefault();
            const options = {
              index: Array.from(images).indexOf(image),
              bgOpacity: 1,
              showHideOpacity: true,
              closeEl: false,
              zoomEl: true, // Zoom aktivieren
              shareEl: false,
              counterEl: false,
              arrowEl: false,
              preloaderEl: false,
              tapToClose: false,
              clickToCloseNonZoomable: false,
              addCaptionHTMLFn: (item, captionEl) => {
                captionEl.children[0].innerHTML = `
                  <div class="custom-controls">
                    <button class="custom-button custom-prev">
                      <svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                        <polyline points="15 18 9 12 15 6"></polyline>
                      </svg>
                    </button>
                    <button class="custom-button custom-close">
                      <svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                        <line x1="18" y1="6" x2="6" y2="18"></line>
                        <line x1="6" y1="6" x2="18" y2="18"></line>
                      </svg>
                    </button>
                    <button class="custom-button custom-next">
                      <svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                        <polyline points="9 18 15 12 9 6"></polyline>
                      </svg>
                    </button>
                  </div>
                `;
                return true;
              }
            };

            const gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);

            gallery.listen('afterChange', function() {
              const prevButton = pswpElement.querySelector('.custom-prev');
              const nextButton = pswpElement.querySelector('.custom-next');
              prevButton.style.display = gallery.getCurrentIndex() === 0 ? 'none' : 'flex';
              nextButton.style.display = gallery.getCurrentIndex() === gallery.items.length - 1 ? 'none' : 'flex';
            });

            gallery.listen('initialZoomInEnd', function() {
              const closeButton = pswpElement.querySelector('.custom-close');
              const prevButton = pswpElement.querySelector('.custom-prev');
              const nextButton = pswpElement.querySelector('.custom-next');

              closeButton.addEventListener('click', () => gallery.close());
              prevButton.addEventListener('click', () => gallery.prev());
              nextButton.addEventListener('click', () => gallery.next());
            });

            gallery.init();
          });
        });
      });
    }
  });
}

// Neuer Code für mobile Geräte
document.addEventListener('DOMContentLoaded', function() {
  const mobileSliderImages = document.querySelectorAll('.mobile-only .product__media-item');
  const pswpElement = document.querySelector('.pswp');

  /*
  mobileSliderImages.forEach((image, index) => {
    image.addEventListener('click', function(e) {
      e.preventDefault();
      const items = Array.from(mobileSliderImages).map(img => ({
        src: img.querySelector('img').src,
        w: img.querySelector('img').naturalWidth,
        h: img.querySelector('img').naturalHeight,
      }));

      const options = {
        index: index,
        bgOpacity: 1,
        showHideOpacity: true,
        closeEl: false,
        zoomEl: true,  // Zoom aktivieren
        shareEl: false,
        counterEl: false,
        arrowEl: false,
        preloaderEl: false,
        tapToClose: false,
        clickToCloseNonZoomable: false,
        addCaptionHTMLFn: (item, captionEl) => {
          captionEl.children[0].innerHTML = `
            <div class="custom-controls">
              <button class="custom-button custom-prev">
                <svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                  <polyline points="15 18 9 12 15 6"></polyline>
                </svg>
              </button>
              <button class="custom-button custom-close">
                <svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                  <line x1="18" y1="6" x2="6" y2="18"></line>
                  <line x1="6" y1="6" x2="18" y2="18"></line>
                </svg>
              </button>
              <button class="custom-button custom-next">
                <svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                  <polyline points="9 18 15 12 9 6"></polyline>
                </svg>
              </button>
            </div>
          `;
          return true;
        }
      };

      const gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);

      gallery.listen('afterChange', function() {
        const prevButton = pswpElement.querySelector('.custom-prev');
        const nextButton = pswpElement.querySelector('.custom-next');
        prevButton.style.display = gallery.getCurrentIndex() === 0 ? 'none' : 'flex';
        nextButton.style.display = gallery.getCurrentIndex() === gallery.items.length - 1 ? 'none' : 'flex';
      });

      gallery.listen('initialZoomInEnd', function() {
        const closeButton = pswpElement.querySelector('.custom-close');
        const prevButton = pswpElement.querySelector('.custom-prev');
        const nextButton = pswpElement.querySelector('.custom-next');

        closeButton.addEventListener('click', () => gallery.close());
        prevButton.addEventListener('click', () => gallery.prev());
        nextButton.addEventListener('click', () => gallery.next());
      });

      gallery.init();
    });
  });
  */
  // Deaktivieren der Standard-Shopify-Lightbox
  const productMediaWrapper = document.querySelector('.product__media-wrapper');
  if (productMediaWrapper) {
    productMediaWrapper.classList.add('pswp-enabled');
  }
});